module.exports = __webpack_public_path__ + "img/book4-active.1fa1f16d.png";